/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Aiflowaskchannels3Inputs */

const en_aiflowaskchannels3 = /** @type {(inputs: Aiflowaskchannels3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Where do you want to use it? The Pulsify cover is always included, every further format costs ${i?.credits} credits.`)
};

const de_aiflowaskchannels3 = /** @type {(inputs: Aiflowaskchannels3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wo willst du es verwenden? Das Pulsify Cover ist immer dabei, jedes weitere Format kostet ${i?.credits} Credits.`)
};

/**
* | output |
* | --- |
* | "Where do you want to use it? The Pulsify cover is always included, every further format costs {credits} credits." |
*
* @param {Aiflowaskchannels3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaskchannels3 = /** @type {((inputs: Aiflowaskchannels3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaskchannels3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaskchannels3(inputs)
	return de_aiflowaskchannels3(inputs)
});
export { aiflowaskchannels3 as "aiFlowAskChannels" }